import { SearchConfig } from "@/components/dynamic-form";

export function getSearchConfig(configFn: () => SearchConfig[]) {
  return configFn();
}
